import {NgModule} from '@angular/core';
import {
  AsignacionSemanaComponent,
  DiaComponent,
  HoraComponent,
  ListaSemanasComponent, PresupuestoSemanaComponent, PresupuestoXDiaSemanaComponent,
  SemanaComponent
} from './components/semana.component';
import {SemanaServices} from './services/semana.services';
import {FriedmanRoutingModule} from './friedman.routing.module';
import {BrowserModule} from '@angular/platform-browser';
import {CommonModule, CurrencyPipe, DecimalPipe} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {MisTiendasComponent, TiendaXSemanaComponent} from './components/tienda.component';
import {TiendaServices} from '../CoreModule/services/tienda.services';
import {AutocompleteModule} from 'ng2-input-autocomplete';
import {AsignacionHorEmpleComponent, AsignHorarioComponent, InputHorarioComponent} from './components/horario.component';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {EmpleadoServices} from '../CoreModule/services/empleado.services';
import {IndicadoresEmpleadosComponent} from './components/indicadores.empleados.component';
import {AccordionModule, CollapseModule} from 'ngx-bootstrap';
import {PlanAccionServices} from './services/plan.accion.services';
import {DetalleEmpleadoComponent} from './components/detalle.empleado.component';
import {IndicadoresServices} from './services/indicadores.services';
import {ListaPlanAccionComponent, PlanAccionComponent, VerPlanAccionComponent} from './components/plan.accion.component';
import {FriedmanSecurityServices} from './services/friedman.security.services';
import {ReportesComponent} from './reportes/reportes.component';
import {ReportesServices} from './services/reportes.services';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {InconsistenciaSemanaComponent} from './components/inconsistencia.semana.component';
import {MultiplesMallasTiendasComponent} from './components/multiples.mallas.tiendas.component';


@NgModule({
  declarations: [
    SemanaComponent,
    DiaComponent,
    HoraComponent,
    AsignacionSemanaComponent,
    TiendaXSemanaComponent,
    AsignHorarioComponent,
    InputHorarioComponent,
    ListaSemanasComponent,
    PresupuestoSemanaComponent,
    PresupuestoXDiaSemanaComponent,
    AsignacionHorEmpleComponent,
    IndicadoresEmpleadosComponent,
    PlanAccionComponent,
    MisTiendasComponent,
    DetalleEmpleadoComponent,
    ListaPlanAccionComponent,
    VerPlanAccionComponent,
    ReportesComponent,
    InconsistenciaSemanaComponent,
    MultiplesMallasTiendasComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    CollapseModule,
    AccordionModule,
    AutocompleteModule.forRoot(),
    NgxDatatableModule,
    NgxChartsModule,
    FriedmanRoutingModule
  ],
  providers: [SemanaServices, CurrencyPipe, TiendaServices, DecimalPipe, EmpleadoServices, PlanAccionServices, IndicadoresServices, FriedmanSecurityServices, ReportesServices],
  exports:[InputHorarioComponent]
})
export class FriedmanModule {

}
